import Head from 'expo-router/head';
import { ScrollView } from 'react-native';
import { getTokenValue, YStack } from 'tamagui';

import APProfilePageUpsellBanner from '@/components/APProfilePageUpsellBanner';
import PSText from '@/components/ui/PSText';

// Copy and CTA are hardwired, so width is the only thing with states: the
// profile page's full-gutter width, and a squeezed box where the title and
// body have to wrap without the button or the wordmark breaking.
const SQUEEZED_WIDTH = 240;

export default function APProfilePageUpsellBannerPreview() {
  return (
    <>
      <Head>
        <title>APProfilePageUpsellBanner · Putting Scene</title>
      </Head>
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: getTokenValue('$color.background', 'color'),
        }}
      >
        <YStack items="flex-start" gap="$lg" p="$lg">
          <YStack gap="$xs">
            <PSText.Body3 color="$textDarkMuted">
              full page width — the profile screen&apos;s real placement
            </PSText.Body3>
            <APProfilePageUpsellBanner onPress={() => {}} />
          </YStack>

          <YStack gap="$xs">
            <PSText.Body3 color="$textDarkMuted">
              squeezed — gallery stress test; the headline and body wrap, the
              CTA still spans the card
            </PSText.Body3>
            <YStack width={SQUEEZED_WIDTH}>
              <APProfilePageUpsellBanner onPress={() => {}} />
            </YStack>
          </YStack>
        </YStack>
      </ScrollView>
    </>
  );
}
